/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unstable-nested-components */
import moment from 'moment';
import React from 'react';
import CommonLog from '../redux/helper/CommonLog';

function LogActivity({ details, componentName }) {
    function ActiveFirst({ details, componentName }) {
        return (
            <>
                {(details?.activated_datetime !== undefined || details?.activated_datetime !== null)
                    ? (

                        <CommonLog
                            date={moment.unix(details.activated_datetime).format('YYYY/MM/DD').split('/').reverse()
                                .join('/')}
                            time={moment.unix(details?.activated_datetime).format('hh:mm a')}
                            name={details.activated_user_name}
                            action="activated"
                            componentName={componentName}
                        />
                    ) : null}

                {(details?.deactivated_datetime !== undefined && details?.deactivated_datetime !== null)
                    ? (
                        <CommonLog
                            date={moment.unix(details.deactivated_datetime).format('YYYY/MM/DD').split('/').reverse()
                                .join('/')}
                            time={moment.unix(details?.deactivated_datetime).format('hh:mm a')}
                            name={details.deactivated_user_name}
                            action="deactivated"
                            componentName={componentName}
                        />
                    ) : null}
            </>
        );
    }
    function DeactiveFirst({ details, componentName }) {
        return (
            <>
                {(details?.deactivated_datetime !== undefined && details?.deactivated_datetime !== null)
                    ? (
                        <CommonLog
                            date={moment.unix(details.deactivated_datetime).format('YYYY/MM/DD').split('/').reverse()
                                .join('/')}
                            time={moment.unix(details?.deactivated_datetime).format('hh:mm a')}
                            name={details.deactivated_user_name}
                            action="deactivated"
                            componentName={componentName}
                        />
                    ) : null}
                {(details?.activated_datetime !== undefined && details?.activated_datetime !== null)
                    ? (
                        <CommonLog
                            date={moment.unix(details.activated_datetime).format('YYYY/MM/DD').split('/').reverse()
                                .join('/')}
                            time={moment.unix(details?.activated_datetime).format('hh:mm a')}
                            name={details.activated_user_name}
                            action="activated"
                            componentName={componentName}
                        />
                    ) : null}
            </>
        );
    }
    function Updated({ details, componentName }) {
        return (
            <>
                {(details?.updated_at !== undefined && details?.updated_at !== null)
                    ? (
                        <CommonLog
                            date={moment.unix(details.updated_at).format('YYYY/MM/DD').split('/').reverse()
                                .join('/')}
                            time={moment.unix(details?.updated_at).format('hh:mm a')}
                            name={details.activated_user_name}
                            action="updated"
                            componentName={componentName}
                        />
                    ) : null}
            </>
        );
    }
    return (
        <div>
            {(details?.activate_datetime !== undefined || details?.deactivated_datetime !== undefined)
                ? moment.unix(details?.activate_datetime).isBefore(moment.unix(details?.deactivated_datetime))
                    ? (
                        <ActiveFirst
                            details={details}
                            componentName={componentName}
                        />
                    ) : <DeactiveFirst details={details} componentName={componentName} /> : null}

            {((details?.updated_at !== undefined || details?.updated_at !== null) && details?.updated_at !== details?.created_at)
            && (
                <Updated
                    details={details}
                    componentName={componentName}
                />
            ) }

        </div>

    );
}

export default LogActivity;
